import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import {
	ClaimUsageIngestionOperator,
	ClaimUsageIngestionUploadDialogResult,
} from './claim-usage-ingestion.models';

@Component({
	selector: 'app-claim-usage-ingestion-upload-dialog',
	styleUrls: ['./claim-usage-ingestion-upload-dialog.component.scss'],
	templateUrl: './claim-usage-ingestion-upload-dialog.component.html',
})
export class ClaimUsageIngestionUploadDialogComponent {
	competenceControl = new FormControl('', {
		nonNullable: true,
		validators: [Validators.required],
	});
	errorMessage = '';
	operatorControl = new FormControl<'' | ClaimUsageIngestionOperator>('', {
		nonNullable: true,
		validators: [Validators.required],
	});
	readonly operatorOptions: {
		label: string;
		value: ClaimUsageIngestionOperator;
	}[] = [
		{ label: 'CNU', value: 'CNU' },
		{ label: 'SulAmérica', value: 'SULAMERICA' },
	];
	selectedFile: File | null = null;

	constructor(
		private readonly dialogRef: MatDialogRef<
			ClaimUsageIngestionUploadDialogComponent,
			ClaimUsageIngestionUploadDialogResult | undefined
		>,
	) {}

	get canSubmit(): boolean {
		return Boolean(
			this.selectedFile &&
				this.competenceControl.valid &&
				this.competenceControl.value.trim() &&
				this.operatorControl.valid &&
				this.operatorControl.value,
		);
	}

	formatBytes(size: number): string {
		if (size < 1024) {
			return `${size} B`;
		}

		if (size < 1024 * 1024) {
			return `${(size / 1024).toFixed(1)} KB`;
		}

		return `${(size / (1024 * 1024)).toFixed(1)} MB`;
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		if (!this.canSubmit || !this.selectedFile) {
			this.competenceControl.markAsTouched();
			this.operatorControl.markAsTouched();

			return;
		}

		this.dialogRef.close({
			competence: this.competenceControl.value.trim(),
			file: this.selectedFile,
			operator: this.operatorControl.value as ClaimUsageIngestionOperator,
		});
	}

	onFileSelected(files: FileList | null): void {
		const file = files?.item(0);

		if (!file) {
			return;
		}

		if (!this.isTxtFile(file)) {
			this.selectedFile = null;
			this.errorMessage = 'Selecione um arquivo .txt.';

			return;
		}

		this.errorMessage = '';
		this.selectedFile = file;
	}

	removeFile(): void {
		this.errorMessage = '';
		this.selectedFile = null;
	}

	private isTxtFile(file: File): boolean {
		return file.name.toLowerCase().endsWith('.txt');
	}
}
